module.exports = __webpack_public_path__ + "9d55e50c.svg";